@if (lengthMarkDraft()) {
    <div class="length-mark">
        <h3 class="h6 condensed">Lengtemarkering invoeren</h3>
        <div class="distance">
            Huidige lengte: {{ !loadingSnappedPoints ? (distanceDraftLengthMark | number) + 'm' : 'Wordt berekend...' }}
            @if (loadingSnappedPoints) {
                <i class="fas fa-spinner fa-spin"></i>
            }
        </div>
        <div class="explain">
            <p>Versleep de kaart naar het eindpunt en klik op het gele vinkje. Na het opslaan kun je de lijn corrigeren.</p>
            <p>Je kunt tussendoor gewoon punaises aanmaken en het eindpunt later opslaan.</p>
        </div>
        @if (lengthMarkDraft() && !distanceDraftLengthMark) {
            <div class="error">
                Sleep het midden van de kaart op een weg om de afstand te berekenen
            </div>
        }
        @if (nonRoadline) {
            <div class="error">
                Lengtemarkering kon niet op een bestaande weg worden getekend
            </div>
        }
        <div>
            <mat-checkbox (change)="drawDraftLengthmark()" [(ngModel)]="lengthMarkUseRoute" class="d-block">
                Tekenen volgens afgelegde route
            </mat-checkbox>
            <mat-checkbox (change)="drawDraftLengthmark()" [(ngModel)]="travelModeWalking" class="d-block">
                Dit is een fiets/wandel pad
            </mat-checkbox>
        </div>
    </div>
}
<div id="map"></div>
<div class="map-backfix-left"></div>
<div class="map-backfix-right"></div>
@if (loading) {
    <app-loading text='Momentje, de kaart wordt geladen...'></app-loading>
}
